import angular from 'angular';

export const SimpleFormInputDirectiveModule = angular
  .module('acme.common.directive.simpleFormInput', [])
  .directive('simpleFormInput', [
    function () {
      return {
        restrict: 'A',
        replace: true,
        transclude: true,
        templateUrl: 'common/directives/simpleFormInput/simpleFormInput.tpl.html',
        scope: {
          errors: '=',
          fieldName: '@',
        },

        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
        },

        controller: [
          '$scope',
          function ($scope) {
            var watcher;

            $scope.simpleFormInput = {
              error: false,

              init: function () {
                watcher = $scope.$watch('errors', function () {
                  if ($scope.errors && $scope.errors[$scope.fieldName]) {
                    $scope.simpleFormInput.error = $scope.errors[$scope.fieldName].message;
                  } else {
                    $scope.simpleFormInput.error = false;
                  }
                });

                $scope.$on('destroy', this.onDestroy);
              },

              onDestroy: function () {
                watcher();
              },
            };

            $scope.simpleFormInput.init();
          },
        ],
      };
    },
  ]).name;
